import { render, staticRenderFns } from "./EmailSendgridEvents.vue?vue&type=template&id=086f4fd2"
import script from "./EmailSendgridEvents.vue?vue&type=script&lang=ts"
export * from "./EmailSendgridEvents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports